'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('map', {
      url: '/account/map',
      template: '<map></map>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null      // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/map/map.routes.js